var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, Watch, PropertyConverters, PacemEventTarget } from './_default-imports';
//namespace Pacem.Components {
let PacemTimerElement = class PacemTimerElement extends PacemEventTarget {
    constructor() {
        super();
        this._handle = 0;
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'interval':
            case 'disabled':
                this._restart();
                break;
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._restart();
    }
    disconnectedCallback() {
        window.clearInterval(this._handle);
        super.disconnectedCallback();
    }
    _restart() {
        clearInterval(this._handle);
        if (!this.disabled && this.interval > 0) {
            this._handle = window.setInterval(() => {
                this.dispatchEvent(new Event("tick", { bubbles: false, cancelable: false }));
            }, this.interval);
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemTimerElement.prototype, "interval", void 0);
PacemTimerElement = __decorate([
    CustomElement({ tagName: P + '-timer' })
], PacemTimerElement);
export { PacemTimerElement };
//}
